<div class="wrapper">
    	<app-admin-header [pageTitle]="tenantName" [pageSubTitle]="tenantSubName"></app-admin-header>
    <div class="student-management-container">
        <!-- Toolbar -->
        <div class="toolbar">
            <mat-form-field appearance="outline" class="search-field">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput placeholder="Search students..." [(ngModel)]="searchText"
                    (ngModelChange)="searchStudents(searchText)" />
            </mat-form-field>

            <button mat-stroked-button class="grey-btn" (click)="onBulkUpload()">
                <mat-icon>upload</mat-icon> Bulk Upload
            </button>

            <button mat-flat-button color="primary" class="dark-blue" (click)="onInviteStudent()">
                <mat-icon>person_add</mat-icon> Invite Student
            </button>

            <button mat-flat-button color="primary" class="dark-blue" (click)="onCreateBatch()">
                <mat-icon>add</mat-icon> Create Batch
            </button>
        </div>

        <!-- Filters -->
        <div class="filters-row-right">
            <div class="filter-item">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-select [(ngModel)]="departmentId" (selectionChange)="onFilterChange()">
                        <mat-option *ngFor="let dept of departments" [value]="dept.id">
                            {{ dept.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="filter-item">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-select [(ngModel)]="batchId" (selectionChange)="onFilterChange()">
                        <mat-option *ngFor="let batch of batches" [value]="batch.id">
                            {{ batch.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <!-- Tabs -->
        <mat-tab-group class="custom-tabs" (selectedIndexChange)="onTabChange($event)">

            <!-- ✅ ACTIVE STUDENTS -->
            <mat-tab label="Active">

                <ng-container *ngIf="(students?.length || 0) > 0; else noActive">
                    <p-table [value]="students" class="p-datatable-gridlines responsive-table">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Batch</th>
                                <th>Department</th>
                                <th>Status</th>
                                <th>Joined On</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-student>
                            <tr>
                                <td>{{ student.name }}</td>
                                <td>{{ student.email }}</td>
                                <td>{{ student.batch }}</td>
                                <td>{{ student.department }}</td>
                                <td><p-tag severity="success" value="{{ student.status }}"></p-tag></td>
                                <td>{{ student.join_date }}</td>
                                <td>
                                    <button pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                                        (click)="deleteStudent(student)">
                                    </button>

                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <p-paginator [rows]="limit" [totalRecords]="totalRecords" (onPageChange)="onPageChange($event)">
                    </p-paginator>
                </ng-container>

                <ng-template #noActive>
                    <div class="no-data">No active students found</div>
                </ng-template>

            </mat-tab>

            <!-- ✅ PENDING INVITES -->
            <mat-tab label="Pending Invites">

                <ng-container *ngIf="(pendingInvites?.length || 0) > 0; else noPending">
                    <p-table [value]="pendingInvites" class="p-datatable-gridlines responsive-table">

                        <ng-template pTemplate="header">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Batch</th>
                                <th>Department</th>
                                <th>Invited On</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-student>
                            <tr>
                                <td>{{ student.name }}</td>

                                <td>
                                    <div class="email-cell" [title]="student.email">
                                        <i class="bi bi-envelope"></i>
                                        <span>{{ student.email }}</span>
                                    </div>
                                </td>

                                <td>{{ student.batch_name }}</td>
                                <td>{{ student.department_name }}</td>

                                <td>
                                    <div class="invited-cell">
                                        <i class="bi bi-clock"></i>
                                        <span>{{ student.invited_on }}</span>
                                    </div>
                                </td>

                                <td>
                                    <button pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                                        (click)="deleteStudent(student)">
                                    </button>

                                </td>
                            </tr>
                        </ng-template>

                    </p-table>

                 <p-paginator [rows]="limit"
             [totalRecords]="totalRecords"
             [first]="(page - 1) * limit"
             (onPageChange)="onPageChange($event)">
</p-paginator>

                </ng-container>

                <ng-template #noPending>
                    <div class="no-data">No pending invites found</div>
                </ng-template>

            </mat-tab>

            <!-- ✅ BY DEPARTMENT -->
            <mat-tab label="By Department">

                <ng-container *ngIf="(departmentSummary?.length || 0) > 0; else noSummary">
                    <div class="department-cards">

                        <div class="dept-card" *ngFor="let row of departmentSummary">
                            <div class="dept-header">
                                <h4>{{ row.batch_name }}</h4>
                                <p>{{ row.department_name }}</p>

                                <p class="year-range">
                                    {{ row.from_year }} - {{ row.to_year }}
                                </p>
                            </div>

                            <div class="dept-stats">
                                <div class="stat">
                                    <span class="label">Total Students</span>
                                    <span class="value">{{ row.total_student_count }}</span>
                                </div>

                                <div class="stat green">
                                    <span class="label">Active</span>
                                    <span class="value">{{ row.active_student_count }}</span>
                                </div>

                                <div class="stat red">
                                    <span class="label">Pending</span>
                                    <span class="value">{{ row.pending_invite_count }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </ng-container>

                <ng-template #noSummary>
                    <div class="no-data">No department summary found</div>
                </ng-template>

            </mat-tab>

        </mat-tab-group>
    </div>
</div>